export default __webpack_public_path__ + "static/media/img-pledge-preferred-status.887f5c94.png";